import React from 'react';
import ComboCheck from '../../components/ComboCheck';

const Filtros = props => (
  <div className='pageHead-rowContainer'>
    <div className='pageHead-filters wrapper'>
      <ComboCheck
        name='Filial'
        nameState='filiales'
        items={props.filiales}
        itemID='id'
        itemName='nombre'
        selectedItems={props.selectedFiliales}
        onChangeGroup={props.onChangeGroup}
        filter={props.filter}
      />
      <ComboCheck
        name='Familia'
        nameState='familias'
        items={props.familias}
        itemID='codFamiliaVeh'
        itemName='desFamiliaVeh'
        selectedItems={props.selectedFamilias}
        onChangeGroup={props.onChangeGroup}
        filter={props.filter}
      />
      <div className='fSearch'>
        <input
          type='number'
          min='1'
          name='unidadMax'
          className='fSearch-search form-control'
          placeholder='Can. Max. Unidades'
          value={props.unidadMax}
          onChange={props.onChangeValue}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              props.filter();
            }
          }}
        />
        <button className='btn btn-dark fSearch-go checkDeGrillaCerrar' type='button' onClick={props.filter}>
          <i className='ion-android-arrow-forward' />
        </button>
      </div>
      <ComboCheck
        name='Tipo de unidad'
        nameState='unidades'
        items={props.unidades}
        itemID='id'
        itemName='nombre'
        selectedItems={props.selectedUnidades}
        onChangeGroup={props.onChangeGroup}
        filter={props.filter}
      />
      <button className='btn pageHead-tableConf-clean checkDeGrillaCerrar' data-toggle='tooltip' data-placement='top' title='Limpiar filtros' data-original-title='Limpiar filtros' onClick={props.reset}>
        <i className='ion-funnel' />
      </button>
    </div>
  </div>
);

export default Filtros;



// WEBPACK FOOTER //
// ./src/pages/MantLugarDespacho/Filtros.js